import { render } from "./AdditionStatique.vue?vue&type=template&id=7aca8ea6&scoped=true"
import script from "./AdditionStatique.vue?vue&type=script&lang=js"
export * from "./AdditionStatique.vue?vue&type=script&lang=js"

import "./AdditionStatique.vue?vue&type=style&index=0&id=7aca8ea6&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aca8ea6"]])

export default __exports__